import { FormProvider as RHFProvider } from "react-hook-form";
export function FormProvider({ form, children, }) {
    return <RHFProvider {...form}>{children}</RHFProvider>;
}
//# sourceMappingURL=FormProvider.js.map